module.exports = new __parcel__URL__("light_mode_24dp_5F6368_FILL0_wght400_GRAD0_opsz24.58c30a3c.svg").toString();